export default __webpack_public_path__ + "static/media/userDashboard.fa9d2d6d.png";